import {
  ModalButtonContainer,
  ModalContainer,
  ModalMessage,
  ModalTitle,
} from 'features/kestrelViewer/ui/popupMenu/shared/SharedModalComponents'
import styled from 'styled-components'

// Overlay - uses shared ModalBackdrop but positioned relative to parent
export const TutorialOverlay = styled.div`
  width: 100%;
  height: 100%;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  pointer-events: none;
  top: 0px;
  left: 0px;

  & > * {
    pointer-events: auto;
  }
`

export const Dialog = styled(ModalContainer)`
  width: 36rem;
  max-width: 90vw;
`

export const DialogTitle = styled(ModalTitle)`
  width: 100%;
`

export const DialogMessage = styled(ModalMessage)`
  width: 100%;
`

export const ControlsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin: 0 0 1.5rem 0;
  width: 100%;
`

export const ControlItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: flex-start;
  text-align: left;
`

export const ControlVideo = styled.video`
  width: 12vh;
  height: 12vh;
  min-height: 6rem;
  mid-width: 6rem;
  object-fit: cover;
  border-radius: 0.5rem;
  flex-shrink: 0;
`

export const ControlContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
`

export const ControlLabel = styled.span`
  font-size: 0.875rem;
  font-weight: 600;
  color: white;
  opacity: 0.95;
`

export const ControlDescription = styled.span`
  font-size: 0.8125rem;
  color: rgba(255, 255, 255, 0.85);
  opacity: 0.9;
`

export const ButtonContainer = styled(ModalButtonContainer)`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 0.5rem;

  button {
    min-width: 100px;
    padding: 0.5rem 1.25rem;
    font-size: 0.875rem;
  }
`

export const TooltipBox = styled(ModalContainer)`
  max-width: 20rem;
`

export const TooltipTitle = styled(ModalTitle)``

export const TooltipText = styled(ModalMessage)`
  margin: 0;
`

export const TooltipContainer = styled.div<{
  $top: string
  $isSubmenu?: boolean
}>`
  position: absolute;
  left: ${({ $isSubmenu }) =>
    $isSubmenu
      ? 'calc(1.5rem + 2.5rem + 0.25rem + calc(2.75rem * 6) + 0.5rem)'
      : 'calc(1.5rem + 2.5rem + 0.5rem)'};
  top: ${({ $top }) =>
    `clamp(8rem, calc(${$top} + 1.25rem), calc(100vh - 12rem))`};
  transform: translateY(-50%);
  transition: top 0.3s ease-out;
  z-index: 1000;
`

export const SettingsTooltipOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 1001;
`

export const BgCover = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998;
`

export const SettingsTooltipContainer = styled.div`
  position: absolute;
  left: calc(50vw + 11rem);
  top: 50vh;
  transform: translateY(-50%);
  opacity: 1;
  pointer-events: auto;
`

export const ViewTooltipContainer = styled.div`
  position: absolute;
  left: calc(10% + 1rem);
  bottom: calc(10% + 1rem);
  z-index: 1000;
  width: calc(80% - 2rem);
`

export const ViewTooltipBox = styled(ModalContainer)`
  width: 100%;
  padding: 1rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const ViewTooltipColumns = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  justify-content: center;
  align-items: stretch;
`

export const ViewTooltipColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  flex: 1;
  text-align: center;
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.4;

  svg {
    transition: transform 0.3s ease-out;
  }

  &:hover svg {
    transform: scale(1.15);
  }

  span {
    display: block;
  }
`

const BaseArrow = styled.div`
  position: absolute;
  width: 0;
  height: 0;
`

export const TooltipArrowLeft = styled(BaseArrow)<{
  $position?: string | undefined
}>`
  left: -0.5rem;
  top: ${({ $position }) => ($position !== undefined ? $position : '50%')};
  transform: translateY(-50%);
  border-top: 0.5rem solid transparent;
  border-bottom: 0.5rem solid transparent;
  border-right: 0.5rem solid rgba(60, 60, 60, 0.7);
  transition: 0.2s all;
`

export const PhotoReelTooltipContainer = styled.div`
  position: absolute;
  left: 50%;
  bottom: 245px;
  transform: translateX(-50%);
  opacity: 1;
  pointer-events: auto;
`

export const TooltipArrowDown = styled(BaseArrow)`
  left: 50%;
  bottom: -0.5rem;
  transform: translateX(-50%);
  border-left: 0.5rem solid transparent;
  border-right: 0.5rem solid transparent;
  border-top: 0.5rem solid rgba(60, 60, 60, 0.7);
`

const BaseHighlight = styled.div<{ $top: string }>`
  position: absolute;
  left: 1.6rem;
  top: ${({ $top }) => $top};
  width: 2.5rem;
  height: 2.5rem;
  border: 3px solid #1890ff;
  border-radius: 0.5rem;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5);
  pointer-events: none;
  z-index: 998;
`

export const TooltipHighlight = styled(BaseHighlight)``

export const SubmenuHighlight = styled(BaseHighlight)`
  box-shadow: none;

  &::after {
    content: '';
    position: absolute;
    left: calc(100% + 0.25rem);
    top: 50%;
    transform: translateY(-50%);
    width: calc(2.75rem * 6);
    height: 2.5rem;
    border: 3px solid #1890ff;
    border-radius: 0.5rem;
    box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5);
  }
`

export const ViewHighlight = styled.div`
  position: absolute;
  left: 10%;
  top: 10%;
  width: 80%;
  height: 80%;
  border: 3px solid #1890ff;
  border-radius: 0.75rem;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5);
  pointer-events: none;
  z-index: 998;
`

export const SidebarTooltipContainer = styled.div`
  position: absolute;
  left: 1.5rem;
  top: 50%;
  transform: translateY(-50%);
  opacity: 1;
  pointer-events: auto;
`

export const IconsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin: 0.75rem 0;
`

export const IconRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  align-items: flex-start;
  color: lightgray;
`

export const StyledIcon = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: left;
  flex-shrink: 0;

  svg {
    width: 20px;
    height: 20px;
    color: lightgray;
  }
`

export const IconDescription = styled.span`
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.4;
`

export const ExitTutorialButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 1002;
  padding: 0.5rem 1rem;
  background-color: rgba(255, 49, 49, 0.9);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  pointer-events: auto;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;

  &:hover {
    background-color: rgba(251, 14, 14, 0.5);
    border-color: rgba(255, 255, 255, 0.3);
  }

  &:active {
    background-color: rgba(40, 40, 40, 0.95);
  }
`

export const TutorialStepCounter = styled.div`
  position: absolute;
  top: 1rem;
  right: calc(1rem + 120px);
  z-index: 1002;
  padding: 0.5rem 1rem;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  pointer-events: auto;
  white-space: nowrap;
`
